import { use, useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../auth/AuthContext";
import { getNewAcessTokenApi, checkAuthApi } from "./authApi";

const ProtectedRoute = ({ children }) => {
  const { isAuth, user, login, logout } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);






  // console.log("Start  current state of content");


  

  // console.log("isAuth value", isAuth);
  // console.log("user value", user)





  // console.log("End  of log current state" ,    )





 const handleCheckAuthApi = async () => {
    try {
      // 1️ Check access token
      const res = await checkAuthApi();

      // console.log("checkAuth success:", res);

      login(res.accessToken, res.user);

    } catch (error) {
      const code = error.response?.data?.code;

      // console.log(" checkAuth failed:", code);

      if (code === "ACCESS_TOKEN_EXPIRED") {
        try {
          const refreshRes = await getNewAcessTokenApi();
          // console.log(" refresh success:", refreshRes);

          login(refreshRes.accessToken, refreshRes.user);

        } catch (err) {

          logout();
        }
      } else {

        //  invalid / missing token

        logout();
        // console.log("user Should logout");
      }
    } finally {
      setLoading(false);
    }
  };






  useEffect(() => {
    handleCheckAuthApi();
  }, []);

  //  auth check in progress
  if (loading) {
    return <div>Checking authentication...</div>;
  }

  //  not authenticated

  if (!isAuth) {
    return <Navigate to="/login" replace />;
  }

  //  authenticated
  return children;
};

export default ProtectedRoute;
